import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { cardsEasyConfigV2 } from "../../../environments/environment";

@Component({
    selector: 'app-cards-easy',
    template: ''
})
export class CardsEasyComponent implements OnInit {

  // constructor(private redirectService: RedirectService) { }
  // ngOnInit(): void {
  //   this.redirectService.redirect(cardsEasyConfig.redirectUri)
  // }

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'];
      if (inApp) {
        cardsEasyConfigV2.redirectUri = cardsEasyConfigV2.redirectUri + '&inApp=true';
      }

    });
  }

  ngOnInit(): void {
    this.loginService.login(cardsEasyConfigV2);
  }

}
